import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import examine from './modules/examine'
import app from './modules/app'
import network from './modules/network'
import SlsTracker from '@/v2/utils/sls'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'production_116' || process.env.NODE_ENV !== 'production_47'

export default new Vuex.Store({
  modules: {
    login,
    examine,
    app,
    network
  },
  state: {
    backDoor: false, // 开发后门
    cardNumType: 'chinese', // chinese 中文、roman 罗马、arabic 阿拉伯数字
    newVersion: true, // 是否为新版本，默认为新版
  },
  mutations: {
    setBackDoor (state, val) {
      state.backDoor = val
    },
    setCardNumType (state, val) {
      state.cardNumType = val
    },
    setNewVersion (state, val) {
      state.newVersion = val
    },
  },
  strict: debug,
  plugins: [
    (store) => {
      Vue.nextTick(initSlsTracker)
      store.subscribe((mutation, state) => {
        if (mutation.type === 'LOGIN_SUCCESS') {
          initSlsTracker()
        }
      })
    }
  ]
})

function initSlsTracker() {
  SlsTracker.reInit()
}


// WEBPACK FOOTER //
// ./src/vuex/store.js